export const inspectTable = [
  {
    content: "안전담당자지정 및 감시인 배치",
    isChecked: "",
  },
  {
    content: "밸브차단, 맹판설치, 불활성가스 치환, 용기세정",
    isChecked: "",
  },
  {
    content: "산소농도 및 유해가스농도 (계속)측정",
    isChecked: "",
  },
  {
    content: "환기시설 설치",
    isChecked: "",
  },
  {
    content: "전화 및 무선기기 구비",
    isChecked: "",
  },
  {
    content: "방폭형 전기기계기구의 사용",
    isChecked: "",
  },
  {
    content: "소화기 비치",
    isChecked: "",
  },
  {
    content: "공기공급식 호흡용보호구 비치",
    isChecked: "",
  },
  {
    content: "안전장구 구비",
    isChecked: "",
  },
  {
    content: "안전교육 실시",
    isChecked: "",
  },
];
